import { useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";

const AUTO_LOGOUT_TIME = 45 * 60 * 1000; // 45 minutes
const ACTIVITY_KEY = "last_activity_timestamp";

const AutoLogout = () => {
  const { currentUser, logout } = useAuth();

  const resetTimer = useCallback(() => {
    if (currentUser) {
      localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
    }
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;

    // Reset timer on mount
    resetTimer();

    const events = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    const handleActivity = () => {
      resetTimer();
    };

    // Add event listeners
    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    // Check interval for auto logout
    const logoutInterval = setInterval(() => {
      const lastActivity = parseInt(localStorage.getItem(ACTIVITY_KEY) || "0");
      const currentTime = Date.now();

      // Only logout if we have a valid lastActivity timestamp AND it is expired
      if (lastActivity > 0 && currentTime - lastActivity >= AUTO_LOGOUT_TIME) {
        console.log("Session expired. Logging out...");
        logout();
        localStorage.removeItem(ACTIVITY_KEY);
      }
    }, 10000); // Check every 10 seconds

    return () => {
      // Cleanup
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(logoutInterval);
    };
  }, [currentUser, logout, resetTimer]);

  return null;
};

export default AutoLogout;
